import { getPricingOfAccountEmailCampaign } from "../types/account_campaign_pricing_email_types";

const initState = {
  data: [],
  loading: false,
  error: null,
};

export default function accountCampaignPricingEmailReducer(state = initState, action = {}) {
  switch (action.type) {
    case getPricingOfAccountEmailCampaign.GET_PRICING_OF_ACCOUNT_EMAIL_CAMPAIGN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case getPricingOfAccountEmailCampaign.GET_PRICING_OF_ACCOUNT_EMAIL_CAMPAIGN_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: null,
      };
    case getPricingOfAccountEmailCampaign.GET_PRICING_OF_ACCOUNT_EMAIL_CAMPAIGN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
